var map = {
	"./admin.svg": 3780,
	"./arrow-right_12.svg": 3643,
	"./close--light.svg": 1421,
	"./close.svg": 1825,
	"./close_16.svg": 2473,
	"./close_20.svg": 1426,
	"./ecology.svg": 6465,
	"./error.svg": 2683,
	"./exit-fullscreen_20.svg": 6496,
	"./file.svg": 8001,
	"./footer.svg": 7326,
	"./industrial.svg": 5086,
	"./info.svg": 2591,
	"./item.svg": 482,
	"./left_32.svg": 3592,
	"./left_48.svg": 451,
	"./logo_RIR--gray.svg": 2391,
	"./logo_RIR--white.svg": 5761,
	"./logo_RIR.svg": 40,
	"./logo_main--white.svg": 6899,
	"./logo_main.svg": 3562,
	"./menu--dark.svg": 6788,
	"./menu.svg": 3782,
	"./modal-close.svg": 1781,
	"./nat1.svg": 3445,
	"./nat2.svg": 7958,
	"./nat3.svg": 5495,
	"./odnoklassniki_16.svg": 1564,
	"./ok.svg": 9645,
	"./play-solid_16.svg": 3715,
	"./play-solid_20.svg": 3988,
	"./play-solid_32.svg": 6498,
	"./play.svg": 5825,
	"./pos1.svg": 8235,
	"./pos2.svg": 8683,
	"./pos3.svg": 1162,
	"./pos4.svg": 8341,
	"./pos5.svg": 1092,
	"./pos6.svg": 5543,
	"./pos7.svg": 6566,
	"./right_32.svg": 3197,
	"./right_48.svg": 3150,
	"./school.svg": 3779,
	"./success.svg": 1296,
	"./telegram_16.svg": 3752,
	"./vkontakte_16.svg": 7344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7477;